export default {
      id: "triangle-down-usage",
      viewBox: "0 0 12 10",
      url: __webpack_public_path__ + "assets/images/lantern-icons.svg#triangle-down",
      toString: function () {
        return this.url;
      }
    }